import React, { useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { deleteWorkOrder } from '../../../../slices/workOrder/thunk';
import { setRequireCloseModal } from '../../../../slices/workOrder/reducer';

const DeleteWorkModal = ({ dataWork, isOpen, handlerToggleModal, toggleRefetch }) => {
	const dispatch = useDispatch();

	const selectorWorkOrder = createSelector(
		state => state.WorkOrder,
		data => ({
			isDeleting: data.isDeleting,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const { isDeleting, requireCloseModal } = useSelector(selectorWorkOrder);

	useEffect(() => {
		if (isOpen && requireCloseModal) {
			dispatch(setRequireCloseModal(false));
			handlerToggleModal();
			if (toggleRefetch) {
				setTimeout(() => toggleRefetch(), 100);
			}
		}
	}, [requireCloseModal]);

	function handlerDelete() {
		dispatch(deleteWorkOrder(dataWork));
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar una Obra!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en confirmar.
						</p>
						<p className='small'>
							Obra: {dataWork !== null ? dataWork.work_order_code: ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button 
								className='btn-danger btn-label' 
								onClick={() => handlerToggleModal()}
							>
								<i className='ri-close-line label-icon'></i> Cancelar
							</Button>
							<button 
								className='btn btn-label btn-primary' 
								onClick={() => handlerDelete()} 
								disabled={isDeleting}
							>
								{isDeleting ? (
									<i className='label-icon'><Spinner size='sm' /></i>
								) : (
									<i className='ri-check-double-line label-icon'></i>
								)} Confirmar
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteWorkModal;
